"use client";

import { c as _c } from "react/compiler-runtime";
import { BankIcon, ChartLineUpIcon, ClockIcon, GlobeHemisphereWestIcon, LightningIcon, LockKeyIcon, ShieldCheckIcon, UsersIcon } from "@phosphor-icons/react";
import Link from "next/link";
import { Button } from "../ui/button";
import { DesktopOnly } from "../ui/desktop-only";
import { Globe } from "../ui/globe";
const capabilities = [{
  icon: ShieldCheckIcon,
  label: "Seguridad Nacional"
}, {
  icon: ChartLineUpIcon,
  label: "Análisis Predictivo"
}, {
  icon: UsersIcon,
  label: "Gestión Ciudadana"
}, {
  icon: BankIcon,
  label: "Finanzas Públicas"
}, {
  icon: LightningIcon,
  label: "Respuesta a Crisis"
}, {
  icon: GlobeHemisphereWestIcon,
  label: "Inteligencia Global"
}];
const features = [{
  icon: LockKeyIcon,
  label: "Privacidad"
}, {
  icon: ClockIcon,
  label: "Latencia"
}, {
  icon: ShieldCheckIcon,
  label: "Cifrado"
}];
export default function GovernmentSection() {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 mb-4"><p className="text-xs font-mono text-background/50">GOV-RP0</p><div className="h-px flex-1 max-w-32 bg-background/20" /></div>;
    t1 = <h2 className="text-5xl md:text-7xl lg:text-8xl font-sans font-bold text-background mb-8">GOBIERNO</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-w-2xl mb-8">{capabilities.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex-1 px-6 py-12 sm:p-12 lg:p-20 flex flex-col justify-center relative z-20">{t0}{t1}{t2}<div className="flex gap-6">{features.map(_temp2)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-sm font-mono text-background leading-relaxed mb-4">Sistemas de toma de decisiones en tiempo real para instituciones gubernamentales. Nuestra plataforma proporciona análisis de datos que impulsan políticas públicas, asignación de recursos y respuesta a crisis con precisión sin precedentes.</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="relative z-20 px-6 py-12 pb-20 sm:px-12 sm:py-12 sm:pb-24 lg:p-20"><div className="max-w-xl">{t4}<Link href="/constitucion"><Button variant="default" size="sm" className="cursor-pointer">Ver Constitución</Button></Link></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-full lg:min-h-screen bg-muted flex flex-col relative overflow-hidden">{t3}{t5}<DesktopOnly><div className="absolute bottom-0 right-0 w-1/2 h-2/3 z-10 flex items-end justify-center pointer-events-none"><Globe /></div></DesktopOnly></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp2(t0) {
  const {
    icon: Icon_0,
    label: label_0
  } = t0;
  return <div key={label_0} className="flex items-center gap-2"><Icon_0 className="size-6 text-background" weight="duotone" /><span className="text-sm font-mono text-background/70">{label_0}</span></div>;
}
function _temp(t0) {
  const {
    icon: Icon,
    label
  } = t0;
  return <div key={label} className="flex items-center gap-2 border border-background/20 bg-background/5 px-3 py-2"><Icon className="size-4 text-background/70" weight="duotone" /><span className="text-xs font-mono text-background/80">{label}</span></div>;
}